import Vuex from 'vuex'
import axios from 'axios'
import env from "@/environments/environment";

const userStore = new Vuex.Store({
    state: {
        username: null,
        id: null,
        masterKey: null,
        token: null,
        password: null
    },
    mutations: {
        login(state, { username, id, token }) {
            state.username = username
            state.id = id
            state.token = token
        },
        logout(state) {
            state.username = null
            state.id = null
            state.token = null
            state.password = null
        },
        admin(state, { masterKey }) {
            state.masterKey = masterKey;
        },
        logoutAdmin(state) {
            state.masterKey = null;
        },
        setPassword(state, { password }) {
            state.password = password;
        }
    },
    actions: {
        async login({ dispatch, commit }, { username, password }) {
            const { data: { token } } = await axios.post(
                `${env.url}/auth`,
                { username, password }
            );

            if (window.localStorage) {
                window.localStorage.setItem('acloud-user-token', token)
            }

            window.sessionStorage.setItem('acloud_password', password);
            commit('setPassword', { password })
            dispatch('loginJwt', { token })
            // commit('login', { username, id: user.id, token })
        },
        async loginJwt({ commit }, { token }) {
            const [, data,] = token.split('.')
            const { username, id, exp } = JSON.parse(atob(data))
            if (Date.now() > exp * 1000) {
                throw new Error('Expired token')
            }

            axios.defaults.headers["Authorization"] = `Bearer ${token}`

            commit('login', { username, id, token })
            if (window.sessionStorage) {
                const password = window.sessionStorage.getItem('acloud_password');
                if (password) {
                    commit('setPassword', { password });
                }
            }
        },
        async logout({ commit }) {
            if (window.localStorage) {
                window.localStorage.removeItem('acloud-user-token')
            }
            if (window.sessionStorage) {
                window.sessionStorage.removeItem('acloud_password')
            }
            commit('logout')
        }
    }
})

export default userStore